import React from "react";
import { ArrowDown, ArrowUp, Plus, Trash } from "@phosphor-icons/react";
import { BTN_WHITE, INPUT } from "./AdminModal";
import { ImageUploadField } from "./ImageUploadField";

const ICON_BTN = "border-2 border-black bg-white p-1 hover:bg-black hover:text-white disabled:opacity-30";

const FieldInput = ({ f, value, onChange, testId }) => {
  if (f.upload) return <ImageUploadField value={value} onChange={onChange} placeholder={f.placeholder} max={f.max} testId={testId} />;
  return f.area ? (
    <textarea className={`${INPUT} h-16 resize-none`} value={value || ""} maxLength={f.max} placeholder={f.placeholder}
              onChange={(e) => onChange(e.target.value)} data-testid={testId} />
  ) : (
    <input className={INPUT} value={value || ""} maxLength={f.max} placeholder={f.placeholder}
           onChange={(e) => onChange(e.target.value)} data-testid={testId} />
  );
};

// Edits a list of small objects. fields: [{ k, placeholder, max, area?, wide?, upload? }]
export function ListEditor({ items, onChange, fields, max, testId, addLabel = "Add" }) {
  const set = (i, k, v) => onChange(items.map((it, j) => (j === i ? { ...it, [k]: v } : it)));
  const move = (i, d) => {
    const n = [...items];
    [n[i], n[i + d]] = [n[i + d], n[i]];
    onChange(n);
  };
  const blank = Object.fromEntries(fields.map((f) => [f.k, ""]));
  return (
    <div className="flex flex-col gap-2" data-testid={testId}>
      {items.map((it, i) => (
        <div key={i} className={`flex gap-2 border border-zinc-300 p-2 ${fields.length === 1 ? "items-center" : "items-start"}`} data-testid={`${testId}-row-${i}`}>
          <div className="grid flex-1 gap-x-2 sm:grid-cols-2">
            {fields.map((f) => (
              <div key={f.k} className={f.wide || fields.length === 1 ? "sm:col-span-2" : ""}>
                <FieldInput f={f} value={it[f.k]} onChange={(v) => set(i, f.k, v)} testId={`${testId}-${i}-${f.k}`} />
              </div>
            ))}
          </div>
          <div className={`flex gap-1 ${fields.length === 1 ? "flex-row items-center self-center" : "mt-1 flex-col"}`}>
            <button type="button" className={ICON_BTN} disabled={i === 0} onClick={() => move(i, -1)} aria-label="Move up" data-testid={`${testId}-up-${i}`}><ArrowUp size={12} /></button>
            <button type="button" className={ICON_BTN} disabled={i === items.length - 1} onClick={() => move(i, 1)} aria-label="Move down" data-testid={`${testId}-down-${i}`}><ArrowDown size={12} /></button>
            <button type="button" className={ICON_BTN} onClick={() => onChange(items.filter((_, j) => j !== i))} aria-label="Remove" data-testid={`${testId}-remove-${i}`}><Trash size={12} /></button>
          </div>
        </div>
      ))}
      {items.length < max && (
        <button type="button" className={`${BTN_WHITE} self-start`} onClick={() => onChange([...items, { ...blank }])} data-testid={`${testId}-add`}>
          <Plus size={11} weight="bold" /> {addLabel}
        </button>
      )}
    </div>
  );
}
